<template lang="html">
  <div class="answer-question-swiper-wrapper">
    <div class="answer-question-swiper">
      <div class="tool-wrapper">
        <el-tooltip class="item" effect="dark" content="放大" placement="top">
          <span class="tool-btn" @click="zoomImg" onselectstart="return!1"><i class="el-icon-plus"></i></span>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="缩小" placement="top">
          <span class="tool-btn" @click="reduceImg" onselectstart="return!1"><i class="el-icon-minus"></i></span>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="旋转" placement="top">
          <span class="tool-btn" @click="rotateImg" onselectstart="return!1"><i class="el-icon-refresh-left"></i></span>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="全屏" placement="top">
          <!-- <span class="tool-btn" @click="fullscreen" onselectstart="return!1"><i class="el-icon-full-screen"></i></span> -->
          <el-image
            style="width: 14px; height: 14px"
            :src="fullImg"
            :preview-src-list="preImgList">
          </el-image>
        </el-tooltip>
      </div>
      <div class="canvas__wrapper" :id="canvasWrapper" :ref="canvasWrapper" style="width: 100%; height: 100%">
        <span class="hasCorrected" v-if="questionsList[currentIndex].teacher_answer_pic">已批注</span>
        <canvas :id="canvasId"></canvas>
      </div>
      <div class="arrow-btns arrow-left" :class="[currentIndex === 0 ? 'disabled' : '']" @click="preve"><i class="el-icon-arrow-left"></i></div>
      <div class="arrow-btns arrow-right" :class="[currentIndex >= questionsList.length - 1 ? 'disabled' : '']" @click="next"><i class="el-icon-arrow-right"></i></div>
      <div class="fullscreenImg" :id="'fullscreenImg' + qs_id"><img :src="questionsList[currentIndex].teacher_answer_pic || questionsList[currentIndex].answer_pic"></div>
      <div class="openMarkPaper" v-if="ifCanEidtByCanvas && ifShowBtn"><el-button type="primary" plain @click="ismark = true">画笔答疑</el-button></div>
      <!-- <div class="openMarkPaper"><el-button type="primary" plain @click="ismark = true">画笔答疑</el-button></div> -->
    </div>
    <!-- <div class="question-attachment">
      附件：
    </div> -->
    <div class="question-attachment" v-if="questionsList[currentIndex] && questionsList[currentIndex].answer_part && questionsList[currentIndex].answer_part.length > 0">
      <div class="left attachments-title">附件：</div>
      <div class="left" v-for="(item, index) in questionsList[currentIndex].answer_part" :key="index">
        <span v-if="Number(item.type) === 3 || Number(item.type) === 4" @click="viewAttachment(item)" class="attachmentIcon" :class="[attachmentType[Number(item.type)]]" slot="reference"></span>
        <span v-if="Number(item.type) === 5" @click="viewAttachment(item)" class="attachmentIcon" :class="[attachmentCustomType[item.customType]]" slot="reference"></span>
        <span v-if="Number(item.type) === 6"  class="attachmentIcon">
          <el-image
            style="width: 14px; height: 14px; position:relative; top: 4px; left: 4px"
            :src="picImg"
            :preview-src-list="[item.content]">
          </el-image>
        </span>
      </div>
    </div>
    <div class="markpaper-wrapper" v-if='ismark'>
      <MarkPaper :userAnswer='questionsList' :qs_id='qs_id' @closeCanvas='closeCanvas'></MarkPaper>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import fullImg from './img/full.png'
import picImg from './img/attach/pic.png'
import axios from 'axios'
import { getURLBase64 } from '@/utils/getURLBase64'
import { SERVER_BASE_URL } from '@/api/api'
import { Loading, Message } from 'element-ui'
import MarkPaper from '@/pages/mark-paper/dayi'
// import * as userAnswer from './mock.json'
// type: 作答内容类型, 1: 文字, 2: 批注, 3: 视频, 4: 音频, 5: 文档(包括word、pdf、压缩包等)
export default {
  props: ['userAnswer', 'ques_id', 'questionsListFromProp', 'canvasId', 'canvasWrapper', 'ifCanEidtByCanvas', 'qs_id', 'ifShowBtn'],
  data () {
    return {
      downX: 0,
      downY: 0,
      moveX: 0,
      moveY: 0,
      translatePointX: 0,
      translatePointY: 0,
      fillStartPointX: 0,
      fillStartPointY: 0,
      moving: false,
      originList: [
        {
          originX: 'left',
          originY: 'top'
        },
        {
          originX: 'left',
          originY: 'bottom'
        },
        {
          originX: 'right',
          originY: 'bottom'
        },
        {
          originX: 'right',
          originY: 'top'
        }
      ],
      l: 0,
      t: 0,
      questionsList: [],
      // questionsList: [
      //   {
      //     img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2F2d.zol-img.com.cn%2Fproduct%2F80%2F139%2Fce5rjFj6gM8BA.png&refer=http%3A%2F%2F2d.zol-img.com.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1618487993&t=37d064b2a5a274003a04557883771b8b',
      //     scale: 1,
      //     angle: 0,
      //     initial: true,
      //     zoom: 1
      //   },
      //   {
      //     img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fbos.pgzs.com%2Frbpiczy%2FWallpaper%2F2013%2F7%2F5%2Ff14c01d71e794db58851057045a090b4-5.jpg&refer=http%3A%2F%2Fbos.pgzs.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1618473337&t=d5f5c16bc0fab65bdfbf618787bee599',
      //     scale: 1,
      //     angle: 0,
      //     initial: true,
      //     zoom: 1
      //   },
      //   {
      //     img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201609%2F12%2F20160912192529_SXazQ.jpeg&refer=http%3A%2F%2Fb-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1618489943&t=e22e2056294d9ac15dba5a0e9d524539',
      //     scale: 1,
      //     angle: 0,
      //     initial: true,
      //     zoom: 1
      //   }
      // ],
      currentIndex: 0,
      ismark: false,
      attachmentType: [
        '',
        '',
        '',
        'video',
        'audio',
        'other'
      ],
      attachmentCustomType: [
        'pdf',
        'word',
        'excel',
        'other'
      ],
      fullImg: fullImg,
      picImg: picImg
    }
  },
  computed: {
    preImgList () {
      return [this.questionsList[this.currentIndex].teacher_answer_pic || this.questionsList[this.currentIndex].answer_pic]
    }
  },
  components: {
    MarkPaper
  },
  created () {
    console.log(this.questionsListFromProp)
    let questionsList = []
    if (Array.isArray(this.questionsListFromProp)) {
      questionsList = this.questionsListFromProp.map((item) => {
        return {
          ...item,
          scale: 1,
          angle: 0,
          initial: true,
          zoom: 1
        }
      })
    }
    this.questionsList = questionsList
    this.questionsList = this.questionsList.map((item) => {
      if (!item.teacher_answer_pic) {
        return item
      } else {
        if (item.teacher_answer_pic.indexOf('https') === -1) {
          let obj = { ...item }
          let teacher_answer_pic = obj.teacher_answer_pic
          teacher_answer_pic = teacher_answer_pic.replace(/http/, 'https')
          obj.teacher_answer_pic = teacher_answer_pic
          return obj
        } else {
          return item
        }
      }
    })
    this.questionsList.forEach((item) => {
      if (item.answer_part) {
        item.answer_part.forEach((onepart) => {
          if (Number(onepart.type) === 5) {
            if (onepart.content.indexOf('.pdf') > -1) {
              onepart.customType = 0
            } else if (onepart.content.indexOf('.dox') > -1 || onepart.content.indexOf('.docx') > -1) {
              onepart.customType = 1
            } else if (onepart.content.indexOf('.xls') > -1) {
              onepart.customType = 2
            } else {
              onepart.customType = 3
            }
          }
        })
      }
    })
    console.log(this.questionsList, this.canvasId, this.canvasWrapper)
  },
  mounted () {
    setTimeout(() => {
      this.init()
    }, 500)
    this.$bus.$on('getNewInfo', this.getNewInfo)
  },
  methods: {
    getNewInfo (origin, newPic) {
      console.log(origin, newPic)
      this.questionsList = this.questionsList.map((item) => {
        if (item.answer_pic === origin) {
          let obj = { ...item }
          obj.teacher_answer_pic = newPic
          return obj
        } else {
          return item
        }
      })
      this.reloadImg()
      console.log(this.questionsList)
    },
    closeCanvas () {
      this.ismark = false
    },
    async init () {
      this.wrap = document.getElementById(this.canvasWrapper)
      this.wrap.style.cursor = 'move'
      // 设置canvas样式
      const canvasWidth = window.getComputedStyle(this.$refs[this.canvasWrapper]).width.slice(0, -2)
      const canvasHeight = window.getComputedStyle(this.$refs[this.canvasWrapper]).height.slice(0, -2)
      console.log(canvasWidth, canvasHeight, this.wrap.style.width, $('.answer-question-swiper').width())
      this.c = document.getElementById(this.canvasId)
      this.context = this.c.getContext('2d')

      this.c.width = canvasWidth
      this.c.height = canvasHeight
      this.fillImageSrc = this.questionsList[this.currentIndex].teacher_answer_pic || this.questionsList[this.currentIndex].answer_pic
      this.img = new Image()
      this.img.setAttribute('crossOrigin', 'Anonymous')
      this.img.src = await getURLBase64(this.fillImageSrc)
      this.img.onload = () => {
        console.log('img 加载成功')
        let scaledWidth = this.img.width * 350 / this.img.height
        let scale = 350 / this.img.height
        this.questionsList[this.currentIndex].scale = scale
        let left = (canvasWidth - scaledWidth) / 2
        this.canvas = new fabric.Canvas(this.canvasId, {
          backgroundColor: '#f5f5f5'
        })
        this.canvas.defaultCursor = `move`
        fabric.Image.fromURL(this.img.src, (img) => {
          img.scale(scale).set({
            left: left,
            top: 0,
            angle: 0,
            hasControls: false,
          });
          this.canvas.add(img).setActiveObject(img);
          this.currentImg = img
        });
      }
      this.img.onerror = (e) => {
        console.log('img 加载失败', e)
      }
    },
    async reloadImg () {
      let currentQuestion = this.questionsList[this.currentIndex]
      this.fillImageSrc = currentQuestion.teacher_answer_pic || currentQuestion.answer_pic
      this.img.src = await getURLBase64(this.fillImageSrc)
      this.img.onload = () => {
        let scaledWidth = this.img.width * 350 / this.img.height
        let scale = 350 / this.img.height
        currentQuestion.scale = scale
        let left = (this.c.width - scaledWidth) / 2
        this.canvas.clear()
        const { originX, originY } = this.originList[currentQuestion.angle / 90]
        fabric.Image.fromURL(this.img.src, (img) => {
          img.scale(scale).set({
            left: currentQuestion.left || left,
            top: currentQuestion.top || 0,
            angle: currentQuestion.angle || 0,
            originX: originX,
            originY: originY,
            hasControls: false,
          });
          this.canvas.add(img).setActiveObject(img);
          let zoomPoint = new fabric.Point(327, 175); // 中心点
          this.canvas.zoomToPoint(zoomPoint, currentQuestion.zoom);
          this.currentImg = img
        });
      }
    },
    preve () {
      if (this.currentIndex === 0) {
        return
      }
      this.currentIndex = this.currentIndex - 1
      this.reloadImg()
    },
    next () {
      if (this.currentIndex === this.questionsList.length - 1) {
        return
      }
      this.currentIndex = this.currentIndex + 1
      this.reloadImg()
    },
    zoomImg () {
      let zoom = this.canvas.getZoom()
      zoom += 0.25
      if (zoom >= 2) {
        zoom = 2
      }
      let zoomPoint = new fabric.Point(327, 175); // 中心点
      this.canvas.zoomToPoint(zoomPoint, zoom);
      this.questionsList[this.currentIndex].zoom = zoom
    },
    reduceImg () {
      let zoom = this.canvas.getZoom()
      zoom -= 0.25
      if (zoom <= 0.5) {
        zoom = 0.5
      }
      let zoomPoint = new fabric.Point(327, 175); // 中心点
      this.canvas.zoomToPoint(zoomPoint, zoom);
      this.questionsList[this.currentIndex].zoom = zoom
    },
    rotateImg () {
      if (this.questionsList[this.currentIndex].angle === 270) {
        this.questionsList[this.currentIndex].angle = 0
      } else {
        this.questionsList[this.currentIndex].angle += 90
      }
      let translateLeft;
      let translateTop
      const { originX, originY } = this.originList[this.questionsList[this.currentIndex].angle / 90]
      if (this.questionsList[this.currentIndex].angle === 90 || this.questionsList[this.currentIndex].angle === 270) {
        translateLeft = (this.canvas.width - this.img.height * this.questionsList[this.currentIndex].scale) / 2
        translateTop = (this.canvas.height - this.img.width * this.questionsList[this.currentIndex].scale) / 2
      } else {
        translateLeft = (this.canvas.width - this.img.width * this.questionsList[this.currentIndex].scale) / 2
        translateTop = (this.canvas.height - this.img.height * this.questionsList[this.currentIndex].scale) / 2
      }
      this.currentImg.set('left', translateLeft)
      this.currentImg.set('top', translateTop)
      this.currentImg.set('angle', this.questionsList[this.currentIndex].angle)
      this.currentImg.set('originX', originX)
      this.currentImg.set('originY', originY)
      this.canvas.requestRenderAll();
      this.questionsList[this.currentIndex].left = translateLeft
      this.questionsList[this.currentIndex].top = translateTop
      this.questionsList[this.currentIndex].originX = originX
      this.questionsList[this.currentIndex].originY = originY
    },
    fullscreen () {
      var el = document.getElementById('fullscreenImg' + this.qs_id)
      var isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
      if (!isFullscreen) { //进入全屏,多重短路表达式
        (el.requestFullscreen && el.requestFullscreen()) ||
        (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
        (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) || (el.msRequestFullscreen && el.msRequestFullscreen())
      } else { //退出全屏,三目运算符
          document.exitFullscreen ? document.exitFullscreen() :
              document.mozCancelFullScreen ? document.mozCancelFullScreen() :
              document.webkitExitFullscreen ? document.webkitExitFullscreen() : '';
      }
    },
    // 查看 下载附件
    // type: 作答内容类型, 1: 文字, 2: 批注, 3: 视频, 4: 音频, 5: 文档(包括word、pdf、压缩包等)
    viewAttachment (item) {
      const url = item.content;
      if (item.content.indexOf('http') == 0) {
        if (item.media_id) {
          var mediaId = item.media_id;
        } else{
          var mediaId = item.content.split("/").pop(0);
        }
      } else{
        if (item.content) {
          var mediaId = item.content;
        } else{
          if (item.media_id) {
            var mediaId = item.media_id;
          } else{
            var mediaId = '';
          }
        }
      }
      if (Number(item.type) === 4 || Number(item.type) === 3) {
        if(mediaId){
          let vidoe_window = window.open('')
          let href =  this.$router.resolve({
            path: '/video-preview/' + mediaId
          })
          vidoe_window.location = href.href
        } else{
          alert('error!')
        }

      } else {
        window.open(url)
      }
    }
  }
}
</script>

<style lang="less">
.answer-question-swiper-wrapper{
  margin-bottom: 20px;
  .canvas__wrapper{
    position: relative;
    .hasCorrected{
      position: absolute;
      left: 5px;
      top: 5px;
      display: inline-block;
      width: 53px;
      height: 23px;
      text-align: center;
      line-height: 23px;
      color: rgb(255, 102, 0);
      z-index: 2;
      font-size: 12px;
      border: 1px solid rgb(255, 102, 0);
      border-radius: 3px;
      background: rgb(255, 242, 232);
    }
  }
  .answer-question-swiper{
    border: 1px solid #e5e5e5;
    width: 100%;
    height: 350px;
    background: #f5f5f5;
    overflow: hidden;
    position: relative;
    .openMarkPaper{
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
    .tool-wrapper{
      position: absolute;
      right: 10px;
      top: 5px;
      z-index: 9;
      .tool-btn{
        cursor: pointer;
        padding: 0 3px;
      }
    }
    .one-swiper{
      width: 100%;
      height: 100%;
      // display: flex;
      // align-items:center;
      // justify-content:center;
      overflow: hidden;
      position: relative;
      img{
        height: 100%;
        width: auto;
        position: absolute;
      }
    }
    .arrow-btns{
      position: absolute;
      width: 36px;
      line-height: 36px;
      height: 36px;
      cursor: pointer;
      border-radius: 50%;
      background: rgba(31, 45, 61, .31);
      color: #fff;
      text-align: center;
      top: 50%;
      transform: translateY(-50%);
      &.arrow-left{
        left: 10px;
      }
      &.arrow-right{
        right: 10px;
      }
      &.disabled{
        background: rgba(31, 45, 61, .11);
        cursor: default;
        display: none;
      }
    }
    .fullscreenImg{
      text-align: center;
      display: flex;
      align-items:center;
      justify-content:center;
    }
  }
  .question-attachment{
    margin-top: 15px;
    overflow: hidden;
    .left{
      float: left;
      .attachmentIcon{
        width: 24px;
        height: 24px;
        background-color: #fafafa;
        border-radius: 4px;
        border: solid 1px #e6e7e8;
        background-position: center;
        background-repeat: no-repeat;
        display: inline-block;
        cursor: pointer;
        margin-left: 10px;
        position: relative;
        top: 0px;
        &.pic{
          background-image: url("./img/attach/pic.png");
          &:hover{
            background-image: url("./img/attach/pic_on.png");
          }
        }
        &.video{
          background-image: url("./img/attach/video.png");
          &:hover{
            background-image: url("./img/attach/video_on.png");
          }
        }
        &.audio{
          background-image: url("./img/attach/audio.png");
          &:hover{
            background-image: url("./img/attach/audio_on.png");
          }
        }
        &.word{
          background-image: url("./img/attach/word.png");
          &:hover{
            background-image: url("./img/attach/word_on.png");
          }
        }
        &.excel{
          background-image: url("./img/attach/excel.png");
          &:hover{
            background-image: url("./img/attach/excel_on.png");
          }
        }
        &.pdf{
          background-image: url("./img/attach/pdf.png");
          &:hover{
            background-image: url("./img/attach/pdf_on.png");
          }
        }
        &.other{
          background-image: url("./img/attach/other.png");
          &:hover{
            background-image: url("./img/attach/other_on.png");
          }
        }
      }
    }
  }
  .markpaper-wrapper{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/question-swiper/question-swiper.vue